import React from 'react';
import { useTranslation } from 'react-i18next';

const AIStarterMoodModal = ({ isOpen, onClose, onSelectMood }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const moods = ['Playful', 'Deep', 'General', 'Humorous', 'Philosophical'];
  const translatedMoods = moods.map(mood => ({ key: mood, value: t(`aiStarterMoodModal.moods.${mood.toLowerCase()}`) }));

  return (
    <div className="modal-overlay">
      <div className="bg-gray-800 p-6 rounded-lg shadow-xl max-w-sm w-full text-white">
        <h3 className="text-xl font-bold mb-4 text-purple-300 font-playfair">{t('aiStarterMoodModal.title')}</h3>
        <div className="grid grid-cols-2 gap-4">
          {translatedMoods.map(mood => (
            <button 
              key={mood.key}
              onClick={() => onSelectMood(mood.key)}
              className="p-4 bg-gray-700 rounded-lg hover:bg-purple-600 transition-colors"
            >
              {mood.value}
            </button>
          ))}
        </div>
        <div className="flex justify-end mt-6">
          <button onClick={onClose} className="px-4 py-2 bg-gray-600 rounded-md hover:bg-gray-700">{t('aiStarterMoodModal.cancel')}</button>
        </div>
      </div>
    </div>
  );
};

export default AIStarterMoodModal;
